import { axiosBase } from "./axios";

const getCommonReports = () => {
  return axiosBase.get('common/commonReports')
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

const getRevenueReport = () => {
  return axiosBase.get('common/revenueReport')
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

const getStudentReport = (params: any) => {
  return axiosBase.get('common/studentReport', { params })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

const getInstructorReport = (params: any) => {
  return axiosBase.get('common/instructorReport', { params })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

export const dashboardService = {
  getCommonReports,
  getRevenueReport,
  getStudentReport,
  getInstructorReport,
};
